<template>
    <div class="row">
        <div class="col-12">
            <vx-heading :level="3">Subscription Statuses</vx-heading>
        </div>
        <template v-if="loading">
            <div class="col-12">
                Loading...
            </div>
        </template>
        <template v-else>
            <div class="col-sm-6 u-mb-small">
                <div class="form-group">
                    <label>Marketing:</label>
                    <vx-select
                        :model-value="marketingStatus"
                        @update:model-value="onMarketingChange"
                        :options="options('marketing')"
                        :close-on-select="true"
                        :deselect-from-dropdown="true"
                        :searchable="false"
                        :clearable="false"
                    >
                    </vx-select>
                </div>
            </div>
            <div class="col-sm-6 u-mb-small">
                <div class="form-group">
                    <label>Transactional:</label>
                    <vx-select
                        :model-value="transactionalStatus"
                        @update:model-value="onTransactionalChange"
                        :options="options('transactional')"
                        :close-on-select="true"
                        :deselect-from-dropdown="true"
                        :searchable="false"
                        :clearable="false"
                    >
                    </vx-select>
                </div>
            </div>
        </template>
    </div>
    <!-- eo .row -->
</template>

<script setup>
import { VxHeading, VxSelect } from '@voxie/frontend-components-v3';
import { ref } from 'vue';
import { useToasted } from '~/components/../composables/useToasted';
import contactsClient from '~/components/../services/contactsClient';

const props = defineProps({
    contactId: {
        type: Number,
        required: false,
    },
});

const teamId = Spark.state.currentTeam.id;
const subscriptions = ref([]);
const $toasted = useToasted();
const loading = ref(false)

const marketingStatus = ref(null);
const transactionalStatus = ref(null);

const emit = defineEmits(['updated']);

const options = (type) => {
    const options = [
        {
            label: "Opt in",
            value: "opt_in",
        },
        {
            label: "Opt out",
            value: "opt_out",
        },
    ];

    if (
        subscriptions.value.find(
            (subscription) =>
                subscription.type === type && subscription.status === "unknown"
        ) || !props.contactId
    ) {
        options.unshift({
            label: "No preference",
            value: "unknown",
        });
    }

    return options;
};

const onMarketingChange = (event) => {
    marketingStatus.value = event;
    emit('updated', {
        type: 'marketing',
        status: event.value,
    }) 
}

const onTransactionalChange = (event) => {
    transactionalStatus.value = event;
    emit('updated', {
        type: 'transactional',
        status: event.value,
    }) 
}

const getSubscriptions = () => {
    loading.value = true;
    contactsClient
        .getContactSubscriptionStatus(teamId, props.contactId)
        .then(({ data }) => {
            subscriptions.value = data.data;

            const hasMarketingSubscription = !!subscriptions.value.find(
                (subscription) => subscription.type === "marketing"
            );
            const hasTransactionalSubscription = !!subscriptions.value.find(
                (subscription) => subscription.type === "transactional"
            );

            if (!hasMarketingSubscription) {
                subscriptions.value.push({
                    type: "marketing",
                    status: "unknown",
                });
            }

            if (!hasTransactionalSubscription) {
                subscriptions.value.push({
                    type: "transactional",
                    status: "unknown",
                });
            }

            marketingStatus.value = options('marketing').find(option => option.value === subscriptions.value.find(subscription => subscription.type === 'marketing').status)
            transactionalStatus.value = options('transactional').find(option => option.value === subscriptions.value.find(subscription => subscription.type === 'transactional').status)
        })
        .catch(() => {
            $toasted.global.platform_error();
        })
        .finally(() => {
            loading.value = false;
        });
};

if(props.contactId) {
    getSubscriptions();
} else {
    marketingStatus.value =  options('marketing').find(option => option.value === 'unknown')
    transactionalStatus.value =  options('transactional').find(option => option.value === 'unknown')
}
</script>
